import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UserState {
  data: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: UserState = {
  data: [],
  isLoading: false,
  error: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUsers: (state, action: PayloadAction<any[]>) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setUserLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setUserError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setUsers, setUserLoading, setUserError } = userSlice.actions;

export default userSlice.reducer;
